module.exports = __webpack_public_path__ + "static/media/main-logo.df14ab18.png";